var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckedFilled = function SvgCheckedFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 2,
    y: 2,
    rx: 4.444
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.164 8.908a.253.253 0 0 0-.022.025l-3.86 4.917-2.325-2.327A.833.833 0 0 0 7.78 12.7l2.94 2.94a.832.832 0 0 0 1.2-.021l4.435-5.545a.833.833 0 0 0-1.19-1.167Z"
  })));
};
export default SvgCheckedFilled;